import React, { useEffect, useState } from 'react';
import { Box, Icons, Typography, useTheme } from '@ublend-npm/aulaui-core';
import { Post } from '@app/types/core';
import { createStyles } from './CommonRoomResponsive.styles';
import PostCard from '../Shared/PostCard';
import useBreakpoints from '@app/hooks/useBreakpoints';
import CommonRoomTabs, { CommonRoomTab } from './CommonRoomTabs';

interface CommonRoomFeedResponsiveProps {
  posts?: Post[];
  readOnly?: boolean;
  pinnedCount?: number;
  onTabChange?: (tab: CommonRoomTab) => void;
}

const CommonRoomFeedResponsive = ({
  posts = [],
  readOnly = false,
  pinnedCount,
  onTabChange,
}: CommonRoomFeedResponsiveProps) => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { md } = useBreakpoints();
  const [activeTab, setActiveTab] = useState<CommonRoomTab>('feed');

  useEffect(() => {
    if (md) {
      setActiveTab('feed');
    }
  }, [md]);

  const handleTabChange = (tab: CommonRoomTab) => {
    setActiveTab(tab);
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  const isPinnedSelected = activeTab === 'pinned';

  return (
    <Box sx={styles.feedLayout} data-testid="responsive-feed-layout">
      <Box
        component="section"
        aria-label="Feed controls"
        sx={styles.feedControlsRegion}
      >
        {!md ? (
          <CommonRoomTabs
            activeTab={activeTab}
            pinnedCount={pinnedCount}
            onTabChange={handleTabChange}
          />
        ) : null}
        <Typography color="text.secondary" sx={styles.feedFilter}>
          Filter
        </Typography>
      </Box>
      <Box
        component="section"
        aria-label="Post composer"
        sx={styles.composerRegion}
      >
        <Box sx={styles.placeholderHeader}>
          <Box sx={styles.placeholderIcon} aria-hidden="true">
            <Icons.EditOutlined fontSize="small" />
          </Box>
          <Box sx={styles.placeholderText}>
            <Typography component="h2" variant="subtitle1">
              Create a post
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Share something with your space…
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        component="section"
        aria-label={
          isPinnedSelected ? 'Pinned Common Room posts' : 'Common Room feed'
        }
        sx={styles.postsRegion}
      >
        <Box sx={styles.postsList}>
          {posts.map((post) => (
            <PostCard key={post.objectId} post={post} readOnly={readOnly} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CommonRoomFeedResponsive;
